/* eslint-disable no-case-declarations */
import {
  FETCH_META_COMPONENT_REQUEST,
  FETCH_META_COMPONENT_SUCCESS,
  FETCH_META_COMPONENT_FAILURE,
} from '../../constants/ActionTypes';

const metaComponents = (state = {}, action) => {
  switch (action.type) {
    case FETCH_META_COMPONENT_REQUEST:
      const reqState = { ...state };

      if (!reqState[action.name]) {
        reqState[action.name] = {};
      }

      reqState[action.name].isFetching = true;
      reqState[action.name].errors = {};

      return reqState;
    case FETCH_META_COMPONENT_SUCCESS:
      const successState = { ...state };

      if (!successState[action.name]) {
        successState[action.name] = {};
      }

      successState[action.name].isFetching = false;
      successState[action.name].errors = {};
      successState[action.name].data = action.data.data;

      return successState;
    case FETCH_META_COMPONENT_FAILURE:
      const failureState = { ...state };

      if (!failureState[action.name]) {
        failureState[action.name] = {};
      }

      failureState[action.name].isFetching = false;
      failureState[action.name].errors = action.data;

      return failureState;
    default:
      return state;
  }
};

export default metaComponents;
